import React from "react";
import PropTypes from "prop-types";
import FontPicker from "font-picker-react";
import Enhancer from "./container";

const FontPickerCustom = ({ onChange, classes, activeFont, pickerId }) => (
  <FontPicker
    pickerId={pickerId}
    apiKey="AIzaSyDm8xG6mYjOimJOXRrdQh-NTkQXAUknlGc"
    activeFontFamily={activeFont}
    onChange={nextFont => onChange(nextFont.family)}
  />
);

FontPickerCustom.propTypes = {
  onChange: PropTypes.func.isRequired,
  activeFont: PropTypes.string,
  classes: PropTypes.object,
  pickerId: PropTypes.string
};

FontPickerCustom.defaultProps = {
  activeFont: "Roboto"
};

FontPickerCustom.displayName = "FontPickerCustom";

export default Enhancer(FontPickerCustom);
